import ajax from "./authenticationSafeAjax";

export function log(subtype, description, customFields={}) {
    sendLogEventTo("/recorder/api/log", subtype, description, customFields);
}

export function logLogin(description) {
    log("login", description);
}

export function logRecordRecommendation(description) {
    log("record-recommendation", description);
}

export function logOpenScreen(description) {
    log("open-screen", description);
}

function sendLogEventTo(logApiUrl, subtype, description, customFields={}) {
    const client_timestamp = new Date().toISOString();
    const request = {
        body: JSON.stringify(Object.assign({
            type: "ClientEvent",
            subtype: subtype,
            client_timestamp,
            client_app_version: global.clientAppVersion,
            description: description,
            user_agent: window.navigator.userAgent
        }, customFields)),
        headers: { "Content-Type": "application/json" },
        url: logApiUrl
    };

    ajax(request, (statusCode, body) => {});
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/logEvent.js
 **/